import { getMetricsApiPrefix } from '../../config/EnvData';
import React, { useState,useEffect,useRef } from "react";
import styled from "styled-components";
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import axios from 'axios';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import {Popper, Chip} from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { stepButtonClasses } from "@mui/material";
import {alpha, Box } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from '@mui/material/CircularProgress';
import Plot from 'react-plotly.js';
import {PlotSectionDiv} from '../../components/DisplayComponents';
import Encroachments from "../metrics/Encroachments";
import emailService from '../../services/emailService';
import { notificationService } from '../../services/notificationService';

// Setup dayjs plugin
dayjs.extend(minMax);

// Helper function to round down to nearest 10 minutes
const roundToNearest10Minutes = (date) => {
    const minutes = date.minute();
    const roundedMinutes = Math.floor(minutes / 10) * 10;
    return date.minute(roundedMinutes).second(0).millisecond(0);
};

const turbCountSectors = ['North','Northeast','East','Southeast','South','Southwest','West','Nortwest']

const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
    '#FB0D0D','#DA16FF','#222A2A']
const axesLineColor ='#FFFF'//'rgba(220,232,247,0.1)'

const defaultColor1 = 'rgba(190,80,60,0.8)'
const defaultColor2 = 'rgba(25,201,108,0.8)'

const axesLineWidth = 5
const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

// Custom DateRangePicker component as fallback
const CustomDateRangePicker = ({ value, onChange, sx, ...props }) => {
    const [startDate, endDate] = value || [null, null];
    
    const handleStartDateChange = (newStartDate) => {
        const newEndDate = endDate || newStartDate?.add(1, 'day');
        onChange([newStartDate, newEndDate]);
    };
    
    const handleEndDateChange = (newEndDate) => {
        onChange([startDate, newEndDate]);
    };
    
    return (
        <div style={{ display: 'flex', gap: '10px', ...sx }}>
            <DateTimePicker
                label="Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                maxDateTime={dayjs()}
                minDateTime={dayjs(new Date(2022, 3, 24))}
                format="YYYY-MM-DD HH:mm"
                slotProps={{
                    textField: { size: 'small', sx: { width: '220px' } }
                }}
                ampm={false}
            />
            <DateTimePicker
                label="End Date"
                value={endDate}
                onChange={handleEndDateChange}
                minDateTime={startDate}
                maxDateTime={startDate ? dayjs.min([dayjs(), startDate.add(60, 'day')]) : dayjs()}
                format="YYYY-MM-DD HH:mm"
                slotProps={{
                    textField: { size: 'small', sx: { width: '220px' } }
                }}
                ampm={false}
            />
        </div>
    );
};

const StyledDateRangePicker = CustomDateRangePicker;
  
const subtractDays = (dateVal,nDays)=>{
    return(new Date(dateVal).getTime() - nDays* 24 * 60 * 60 * 1000)
}
const addDays = (dateVal,nDays)=>{
    return(new Date(dateVal).getTime() + nDays* 24 * 60 * 60 * 1000)
}

//  {title:'Turbulence Counts',selectLabel:'turbulence-counts',apiMetricKey:'turbCountData'},
const METRICS = [{title:'Number of Aircraft', selectLabel:'numAC',apiMetricKey:'numAC'},
                 {title:'Buffer Encroachments',selectLabel:'encroachments',apiMetricKey:'encrData'},
                 {title:'Centerline Deviations',selectLabel:'centerline-deviations',apiMetricKey:'centerlineDev'},
                 {title:'Go-around Counts', selectLabel:'go-around-counts',apiMetricKey:'goAroundCountData'},
                 {title:'Flight Plan Change Counts',selectLabel:'flight-plan-change-counts',apiMetricKey:'fpeCountData'},
                 {title:'Workload Proxy Metrics',selectLabel:'vectoring-counts',apiMetricKey:'turnVectorData'}]

const getTraceForMetric =(idx,selectedMetric,dataRes) => {
    var metricVal; 
    var ref = parseInt(idx)+1
    if(selectedMetric.apiMetricKey ==='encrData'){
        metricVal= [{x: dataRes['Epoch'],
                          y: dataRes['EncrDur']['Adjusted'],
                          type: 'scatter',
                          mode: 'lines',
                          marker: {color: defaultColor1},
                          name:'Adjusted Encroachment Duration',
                          hovertemplate:'%{y}<extra>Adj. EncrDur [s]</extra>',
                          xaxis:'x',yaxis:ref===1?'y':'y'+ref,
                          showlegend:false,
                        }]
    }else if(selectedMetric.apiMetricKey === 'numAC'){
        metricVal = [{x: dataRes['Epoch'],
            y: dataRes['NumACTotal'],
            type: 'scatter',
            mode: 'lines',
            marker: {color: defaultColor1},
            name:'TotalNumAC',
            hovertemplate:'%{y}<extra>NumAC</extra>',
            xaxis:'x',yaxis:ref===1?'y':'y'+ref,
            showlegend:false,
            }]
    }else if(selectedMetric.apiMetricKey === 'centerlineDev'){
        metricVal = [{x:dataRes['Epoch'],
            y:dataRes['MeanDeviation_ft'],
            type: 'scatter',
            mode: 'lines',
            marker: {color: defaultColor1},
            name:'TotalNumAC',
            hovertemplate:'%{y}<extra>NumAC</extra>',
            xaxis:'x',yaxis:ref===1?'y':'y'+ref,
            showlegend:false,
        }]
    }else if(selectedMetric.apiMetricKey === 'goAroundCountData'){
        metricVal = [{x:dataRes['Epoch'],
                      y:dataRes['goAround15min'],
                      type: 'scatter',
                      mode: 'lines',
                      marker: {color: defaultColor1},
                      name:'Go-around Counts',
                      hovertemplate:'%{y}<extra>Go-arounds (15 Min. Counts)</extra>',
                      xaxis:'x',yaxis:ref===1?'y':'y'+ref,
                      showlegend:false
                    }, 
                    {x:dataRes['Epoch'],
                        y:dataRes['holdingPattern15min'],
                        type: 'scatter',
                        mode: 'lines',
                        marker: {color: defaultColor2},
                        name:'Holding Pattern Counts',
                        hovertemplate:'%{y}<extra>Holding Patterns (15 Min. Counts)</extra>',
                        xaxis:'x',yaxis:ref===1?'y':'y'+ref,
                        showlegend:false,
                      }, 
                ]
    }else if(selectedMetric.apiMetricKey === 'turbCountData'){
        metricVal = []
        for(var sec_idx in turbCountSectors){
            var field = turbCountSectors[sec_idx]+'5min'
            if(Object.hasOwn(dataRes,field)){
                metricVal.push({
                                x: dataRes.Epoch,
                                y: dataRes[field],
                                type:'scatter',
                                mode:'lines',
                                hovertemplate:'%{y}<extra>'+field.split('5')[0]+'</extra>',
                                name:'Turbulence Count ('+field.split('5')[0]+')',
                                marker: {color: colorPalette[sec_idx+1]},
                                xaxis:'x',
                                yaxis:ref===1?'y':'y'+ref,
                                showlegend:false,
                                })
            }
            
        }        
    
        metricVal.push({
                        x: dataRes['Epoch'],
                        y: dataRes['Total5min'],
                        type: 'scatter',
                        mode: 'lines',
                        marker: {color: colorPalette[12]},
                        hovertemplate:'%{y}<extra>Total</extra>',
                        name:'Turbulence Counts (Total)',
                        xaxis:'x',
                        yaxis:ref===1?'y':'y'+ref,
                        showlegend:false,
                    })
    }else if(selectedMetric.apiMetricKey === 'fpeCountData'){
        metricVal=[{x:dataRes['Epoch'],
                    y:dataRes['15min'],
                    type: 'scatter',
                        mode: 'lines',
                        marker: {color: defaultColor1},
                        name:'Flight Plan Change Counts',
                        hovertemplate:'%{y}<extra>15 min Counts</extra>',
                        xaxis:'x',yaxis:ref===1?'y':'y'+ref,
                        showlegend:false,
                    }]
    }else if(selectedMetric.apiMetricKey === 'turnVectorData'){
        metricVal = []
        for(var vectMet of ['Heading','Speed','Altitude']){
            metricVal.push({x:dataRes['Epoch'],
                            y:dataRes['VectorCounts.'+vectMet],
                            type: 'scatter',
                            mode: 'lines',
                            name:'Vectoring Counts ('+vectMet+')',
                            hovertemplate:'%{y}<extra>'+vectMet+' Counts</extra>',
                    xaxis:'x',yaxis:ref===1?'y':'y'+ref,
                    showlegend:false,
                })
        }
    }
    return metricVal
};
const HistoricData = ({setTitle,pageTitle,activeAirport,airportDataList,backendApiPrefix,notificationData}) => {
    
    const [selectedAirport,setSelectedAirport] = useState()
    const defaultSelectedMetrics = [METRICS[0],METRICS[1]]
    const [selectedMetrics, setSelectedMetrics] = useState(defaultSelectedMetrics)
    const [selectedDateRange, setSelectedDateRange] = useState([
        roundToNearest10Minutes(dayjs().subtract(1, 'hour')),
        roundToNearest10Minutes(dayjs())
    ])
    const [airportList,setAirportList] = useState([])

    // Helper variables for backward compatibility
    const selectedStartDate = selectedDateRange[0]
    const selectedEndDate = selectedDateRange[1]

    const [metricTraceData, setMetricTraceData] = useState([])
    const [showPlotFlag,setShowPlotFlag] = useState(false)
    const [dataLoadingStatus,setDataLoadingStatus] = useState('')
    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:1,columns:1,ygap:0.2,pattern:'independent'},
        xaxis:{anchor:['y'],
                zeroline:false,
                range:[selectedStartDate,selectedEndDate],
                rangeselector:{
                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                            {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                            {count:1,label:'1d',step:'day',stepmode:'backward'},
                            {count:7,label:'1wk',step:'day',stepmode:'backward'},
                            {count:1,label:'1mth',step:'month',stepmode:'backward'},
                            {step:'all'}]},
                type:'date',  		
                showticklabels:true,
                nticks:7,mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth,
                autorange:true},
        yaxis:{anchor:'x',title:'',zeroline:false,showticklabels:true,
                mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth},
        legend:{x:0.5,xanchor:'left',y:1.02,bgcolor:'rgba(0,0,0,0)',orientation:'h'},
        annotations:[],
        margin:{t:34,r:10,b:20},
        hovermode:'x unified',
        plot_bgcolor:'rgba(220,232,247,0.4)'});

    const [plotChartData,setPlotChartData] = useState([])

    const [openQueryMonitorDialogFlag,setOpenQueryMonitorDialogFlag] = useState(false)
    const [openDownloadDialogFlag,setOpenDownloadDialogFlag] = useState(false)
    const [currentAction,setCurrentAction] = useState('') // 'download' or 'email'
    
    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
        'toggleSpikelines','select2d',
        'zoomIn2d','zoomOut2d','lasso2d',
        'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
        'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
        'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
        'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
        'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
        'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
         displaylogo:false,responsive:true})
    useEffect(() => {
        setTitle(pageTitle=>'Historic Data')
    },[]);
    
    useEffect(() => {
        setAirportList(Object.keys(airportDataList));
        setSelectedAirport(Object.keys(airportDataList)[0])
      }, [airportDataList]);

    const handleChange = (event, newValue) => {
        setSelectedMetrics(newValue.reverse());
      };
    
    const getMetricData = ()=>{
        var historicData_api =  backendApiPrefix+'/api/get-historic-metric-data/'
        Promise.all(selectedMetrics.map(obj => axios.post(historicData_api,{airport:selectedAirport,metric:obj.apiMetricKey,from:selectedStartDate,to:selectedEndDate})))
            .then(axios.spread((...dataRes) =>{
                console.log("RECEIVED")
                var metricVal = []
                var layoutVal = plotChartLayout;
                var yAxName; var xAxName;
                var yAnchor = []
                var yHeight = 0.98*1/selectedMetrics.length
                for(var idx in selectedMetrics){
                    console.log("IDX",idx)
                    metricVal = [...metricVal,...getTraceForMetric(idx,selectedMetrics[idx],dataRes[idx].data.message)]
                    var ref = parseInt(idx)+1
                    console.log("REF",ref)
                    if(ref===1){
                        yAxName = 'yaxis'
                        yAnchor.push('y')
                    }else{
                        yAxName = 'yaxis'+ref
                        yAnchor.push('y'+ref)
                        xAxName = 'xaxis'+ref
                    }
                    
                    layoutVal = {...layoutVal,
                                    [yAxName]:{
                                        ...layoutVal['yaxis'],
                                        title:{text:selectedMetrics[idx]['title'],font:{size:12}},
                                        domain:[yHeight*parseInt(idx),yHeight*(parseInt(idx)+1)],
                                        autorange:true}}
                    if(xAxName){
                        layoutVal[xAxName] = {title:{standoff:15}}
                    }

                };
                setMetricTraceData(metricVal)
                setPlotChartLayout({...plotChartLayout,
                                        xaxis:{...plotChartLayout.xaxis,anchor:yAnchor},
                                        grid:{...plotChartLayout.grid,rows:selectedMetrics.length},
                                    ...layoutVal,
                                        height:200*selectedMetrics.length})
                setDataLoadingStatus('complete')
            }))
            .catch(error => {
                console.log(error);
              });       
    }
    const handleAirportSelection =(event,newValue)=>{
        setSelectedAirport(newValue || '')
    }
    const handlePlotting = ()=>{
        setShowPlotFlag(true)
        setTitle(pageTitle=>'Historic Data - '+selectedAirport)
        setMetricTraceData([])
        setPlotChartLayout({grid:{rows:1,columns:1,ygap:0.2,pattern:'independent'},
                                xaxis:{anchor:['y'],
                                        zeroline:false,
                                        range:[selectedStartDate,selectedEndDate],
                                        title:{standoff:15},
                                        rangeselector:{
                                                buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                                                    {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                                                    {count:1,label:'1d',step:'day',stepmode:'backward'},
                                                    {count:7,label:'1wk',step:'day',stepmode:'backward'},
                                                    {count:1,label:'1mth',step:'month',stepmode:'backward'},
                                                    {step:'all'}]},
                                        type:'date',  		
                                        showticklabels:true,
                                        nticks:7,mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth,
                                        autorange:true},
                                yaxis:{anchor:'x',title:'',zeroline:false,showticklabels:true,autorange:true,
                                        mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth},
                                legend:{x:0.5,xanchor:'left',y:1.02,bgcolor:'rgba(0,0,0,0)',orientation:'h'},
                                annotations:[],
                                margin:{t:54,r:10,b:20},
                                hovermode:'x unified',
                                plot_bgcolor:'rgba(220,232,247,0.4)'})


        if((selectedAirport==='')||(selectedMetrics.length===0)||(selectedEndDate.diff(selectedStartDate,'day') > 60)){
            setOpenQueryMonitorDialogFlag(true);
        }
        else{
            setDataLoadingStatus('loading')
            getMetricData()
        }
        
    }
    const handleCloseQueryMonitorDialog = ()=>{
        setOpenQueryMonitorDialogFlag(false)
    }
    const handleCloseDownloadDialog = ()=>{
        setOpenDownloadDialogFlag(false)
    }

    const handleDownload = () => {
        setCurrentAction('download')
        if((selectedAirport==='')||(selectedMetrics.length===0)){
            setOpenQueryMonitorDialogFlag(true);
            return
        }

        // Show confirmation dialog only
        setOpenDownloadDialogFlag(true)
    }
    
    
    const executeDownload = async () => {
        setOpenDownloadDialogFlag(false)
        const userEmail = await emailService.getCurrentUserEmail();
        // Prepare data for queue API
        const downloadData = {
            airport: selectedAirport,
            selectedMetrics: selectedMetrics,
            from: selectedStartDate.toISOString(),
            to: selectedEndDate.toISOString(),
            sendEmail: false,
            recipientEmail:userEmail,
            callbackUrl: backendApiPrefix + '/api/job-completion-callback/'
        };

        // Queue the job using the new API
        const queueUrl = getMetricsApiPrefix() + 'historic-data/queue-historic-data-processing'
        
        console.log('Sending request to queue API:', downloadData);
        const response = await axios.post(queueUrl, downloadData);
        console.log('Queue API response:', response.data);
        // setPendingRequests(prevVal=>[...prevVal,{...response.data, isEmailRequest: false}])
    }

    const handleEmailing = ()=>{
        setCurrentAction('email')
        if((selectedAirport==='')||(selectedMetrics.length===0)){
            setOpenQueryMonitorDialogFlag(true);
            return
        }

        // Show confirmation dialog only
        setOpenDownloadDialogFlag(true)
    }

    const executeEmailing = async ()=>{
        setOpenDownloadDialogFlag(false)
        const userEmail = await emailService.getCurrentUserEmail();
        console.log('User email for email request:', userEmail);
        
        if (!userEmail) {
            throw new Error('Could not get user email');
        }
        
        // Prepare data for queue API with email
        const emailData = {
            airport: selectedAirport,
            selectedMetrics: selectedMetrics,
            from: selectedStartDate.toISOString(),
            to: selectedEndDate.toISOString(),
            sendEmail: true,
            recipientEmail: userEmail,
            callbackUrl: backendApiPrefix + '/api/job-completion-callback/'
        };

        // Queue the job using the new API
        const queueUrl = getMetricsApiPrefix() + 'historic-data/queue-historic-data-processing'
        
        console.log('Sending email request to queue API:', emailData);
        const response = await axios.post(queueUrl, emailData);
        console.log('Email queue API response:', response.data);
        // setPendingRequests(prevVal=>[...prevVal,{...response.data, isEmailRequest: true}])
    }
    
    const handleDateRangeChange = (newValue) => {
        // Ensure both start and end dates are provided
        if (newValue[0] && newValue[1]) {
            // Validate the range is not more than 60 days
            const daysDiff = newValue[1].diff(newValue[0], 'day');
            if (daysDiff <= 60) {
                setSelectedDateRange(newValue);
            } else {
                // If range is too large, adjust end date to be 60 days from start
                setSelectedDateRange([newValue[0], newValue[0].add(60, 'day')]);
            }
        } else if (newValue[0] && !newValue[1]) {
            // If only start date is selected, auto-set end date to 1 day later
            setSelectedDateRange([newValue[0], newValue[0].add(1, 'day')]);
        } else {
            setSelectedDateRange(newValue);
        }
    };

    const handlePresetDateRange = (preset) => {
        const now = dayjs();
        let startDate, endDate;
        
        switch (preset) {
            case '1hour':
                startDate = now.subtract(1, 'hour');
                endDate = now;
                break;
            case '6hours':
                startDate = now.subtract(6, 'hour');
                endDate = now;
                break;
            case '1day':
                startDate = now.subtract(1, 'day');
                endDate = now;
                break;
            case '3days':
                startDate = now.subtract(3, 'day');
                endDate = now;
                break;
            case '1week':
                startDate = now.subtract(1, 'week');
                endDate = now;
                break;
            case '1month':
                startDate = now.subtract(1, 'month');
                endDate = now;
                break;
            default:
                return;
        }
        
        setSelectedDateRange([startDate, endDate]);
    };

    return <Layout>
                <PlotSectionDiv id="chartPlotDiv" flexRatio={1}>
                    <Autocomplete
                    options={airportList}
                    style={{ width: 150,height:50,marginTop:10,marginLeft:10}}
                    onChange={handleAirportSelection}
                    value={selectedAirport || ''}
                    getOptionLabel={(option) => option || ''}
                    renderInput={(params) => <TextField {...params} sx={{ height: 1 }} label="Airport" size="small"/>}
                    />
                    <Autocomplete
                    multiple
                    id="tags-standard"
                    options={METRICS}
                    value={selectedMetrics}
                    getOptionLabel={(option) => option.title}
                    getOPtionSelected={(option) => option.selectLabel}
                    defaultValue={defaultSelectedMetrics}
                    style={{marginTop:10,marginLeft:10,marginRight:10,marginBottom:20}}
                    onChange={handleChange}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        variant="standard"
                        placeholder={selectedMetrics.length===0?"Select Metrics":''}
                        />
                    )}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StyledDateRangePicker
                            sx={{ marginLeft: 1 }}
                            value={selectedDateRange}
                            onChange={handleDateRangeChange}
                        />
                    </LocalizationProvider>
                    <div style={{marginLeft:'10px', width:'50%',display:'flex',justifyContent:'flex-start',marginRight:'10px',marginTop:'20px'}}>
                    <Button style={{height:'32px',minWidth: '125px', backgroundColor:'#275AA6', maxWidth: '150px',marginRight:'10px'}} 
                        variant="contained" onClick={handlePlotting}>Plot</Button>
                    <Button style={{height:'32px',minWidth: '150px', backgroundColor:'#275AA6',maxWidth: '150px',marginRight:'10px'}} 
                        variant="contained" onClick={handleDownload}>Download</Button>
                    <Button style={{height:'32px',minWidth: '140px', backgroundColor:'#275AA6',maxWidth: '150px',marginRight:'10px'}} 
                        variant="contained" onClick={handleEmailing}>Email</Button>
                    </div>
                    {dataLoadingStatus==='loading'&&<Box sx={{ display:'fixed',width:'100%',height:'100%',marginTop:1,justifyContent:'flex-center',zIndex:3,position:"absolute",backgroundColor:'rgba(100,100,100,0.3)'}}>
                    <CircularProgress style={{marginTop:'20vh'}}/>
                    </Box>}
                    {showPlotFlag&&<Plot  data={metricTraceData}
                    layout= {plotChartLayout}
                    config= {plotConfig}
                    divId={'plotlyChartDiv'}
                    style={{minWidth:'300px',width:'95%',position:'relative',marginLeft:-10}}
                    useResizeHandler={true}
                    />}
                </PlotSectionDiv>
                <Dialog open={openQueryMonitorDialogFlag} onClose={handleCloseQueryMonitorDialog}>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div>{(selectedEndDate.diff(selectedStartDate,'day') > 60)?'Time period should be less than 60 days':''}</div>
                            <div>{selectedAirport===''?'Airport not selected':''}</div>
                            <div>{selectedMetrics.length===0?'Metric not selected':''}</div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleCloseQueryMonitorDialog} variant="contained" 
                            sx={{ backgroundColor: '#275AA6', '&:hover': { backgroundColor: '#1e4a8c' } }}>Ok</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openDownloadDialogFlag} onClose={handleCloseDownloadDialog}>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {currentAction === 'email' ? (
                                <div>
                                    <div>✉️ <strong>Email notification will be sent</strong> when your data is ready</div>
                                    <div style={{marginTop: '10px', fontSize: '0.9em', color: '#666'}}>
                                        The download link will be sent to your registered email address
                                    </div>
                                    <div style={{marginTop: '15px', fontSize: '0.95em'}}>
                                        Do you want to proceed with the email request?
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div>📱 <strong>You will be notified when download link is ready </strong></div>
                                    <div style={{marginTop: '10px', fontSize: '0.9em', color: '#666'}}>
                                        Check the notifications bar for your download link
                                    </div>
                                    <div style={{marginTop: '15px', fontSize: '0.95em'}}>
                                        Do you want to proceed with the download request?
                                    </div>
                                </div>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDownloadDialog}>Cancel</Button>
                        <Button onClick={currentAction === 'email' ? executeEmailing : executeDownload} variant="contained" 
                                sx={{ backgroundColor: '#275AA6', '&:hover': { backgroundColor: '#1e4a8c' } }}>
                            {currentAction === 'email' ? 'Send Email' : 'Download'}
                        </Button>
                    </DialogActions>
                </Dialog>
        </Layout>
};
// component={Link} to={"/metrics/airport-summary/"+airport
    
export default HistoricData